<template>
    <div>
        <div class="m-2">
            <b-row>
                <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
                </b-col>
                <b-col cols="12" md="6">
                    <div class="d-flex align-items-center justify-content-end">
                        <b-form-input v-model="searchQuery" class="d-inline-block mr-1"
                            placeholder="Search..." />
                        <Addplugin @fetchPlugin="fetchPlugins" />
                        <!-- <EditpluginData :theme="editTheme"/> -->

                        <EditpluginData
                        :theme="editTheme"
                        @fetchPlugin="fetchPlugins"
                        @removeThemeData="removeThemeData"
                      />
                        <!-- <Addplugin :manage="isManageThemes" :token="bearerToken" @fetchThemes="fetchThemes" /> -->
                    </div>
                </b-col>
            </b-row>
        </div>
        <!-- <EditTheme :token="token" :theme="editTheme" @fetchThemes="fetchThemes" @removeThemeData="removeThemeData" /> -->
   <div>
  <!-- Show table only if data exists -->
  <b-table
    v-if="FilteredItems.length > 0"
    :items="FilteredItems"
    :fields="fields"
    responsive
    class="mb-0"
    id="theme-table"
  >
    <!-- Index -->
    <template #cell(index)="data">
      {{ data.index + 1 }}
    </template>

    <!-- Path -->
    <template #cell(path)="data">
      <span
        class="d-inline-block"
        style="max-width: 350px; white-space: normal; word-break: break-all;"
      >
        {{ data.item.path == null ? 'N/A' : data.item.path }}
      </span>
    </template>

    <!-- Actions -->
    <template #cell(action)="data">
      <div class="d-flex align-items-center">
        <b-dropdown variant="link" no-caret>
          <template #button-content>
            <feather-icon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
          </template>
          <b-dropdown-item @click="editPluginData(data.item)">
            <div>
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </div>
          </b-dropdown-item>
          <b-dropdown-item @click="deletePlugin(data.item._id, data.item.title)">
            <div>
              <b-spinner v-if="loading" small class="mr-1" />
              <feather-icon v-else icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </div>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </template>
  </b-table>

  <!-- Custom empty state -->
 <div
  v-else
  class="text-center my-4"
  :style="{ marginTop: '100px !important' }"
>
  No record found
</div>
</div>
</div>
    
</template>


<script>
import {
  BFormInput,
  BButton,
  BTable,
  BDropdown,
  BDropdownItem,
  BOverlay,
  BFormGroup,
  BSpinner,
  BCol,
  BCard,
  BRow,
} from "bootstrap-vue";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import vSelect from "vue-select";


export default {
  components: {
    Addplugin: () => import("./AddRemotePlugin.vue"),
    EditpluginData: () => import("./EditRemotePlugin.vue"),
    BButton,
    BFormInput,
    BFormGroup,
    BTable,
    BDropdown,
    BDropdownItem,
    BOverlay,
    BSpinner,
    BRow,
    BCol,
    vSelect,
    ToastificationContent,
  },
  data() {
    return {
      fields: [
        "index",
        { key: "title", label: "Title" },
        { key: "plugin", label: "Code" },
        { key: "path", label: "Url" },
        { key: "action", label: "ACTION" },
      ],
      searchQuery: "",
    
      loading: false,
      loadingData: false,
      topicDetails: [],
      detailsTittle: "",
      editTheme: {},
      alertMessageToast: "",
      plugins: [],
    };
  },
  created() {
    this.fetchPlugins();
    
  },
  computed: {
    FilteredItems() {
      
      if (!this.searchQuery) {
        return this.plugins;
      }
      const query = this.searchQuery.toLowerCase();
      return this.plugins.filter((plugin) => {
        return (
          (plugin.title && plugin.title.toLowerCase().includes(query)) ||
          (plugin.plugin && plugin.plugin.toLowerCase().includes(query)) ||
          (plugin.path && plugin.path.toLowerCase().includes(query))
        );
      });
    },
  },
  methods: {
    openPluginDetails(plugin) {
    this.topicDetails = plugin.topicDetails || [];
    this.detailsTittle = plugin.title;
    this.$bvModal.show("details-modal");
    },
    fetchPlugin() {
            this.fetchPlugins()
        },

    async fetchPlugins() {
      
      this.loading = true;

      try {
        const response = await axios.get(
          `${process.env.VUE_APP_API_URL}/remote-plugins/get-all`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("_t")}`,
            },
          }
        );

        if (response.data.success) {
          const plugins = response.data.data;
          this.plugins = plugins;
        } else {
          this.showToast("danger", "Failed to fetch plugins.");
        }
      } catch (err) {
        this.showToast("danger", "Error fetching plugins or topic details.");
      } finally {
        this.loading = false;
      }
    },

    showToast(variant, message) {
      this.alertMessageToast = message;
      this.$toast({
        component: ToastificationContent,
        props: {
          title: "Notification",
          icon: "BellIcon",
          text: this.alertMessageToast,
          variant,
        },
      });
    },

    removeThemeData() {
      this.editTheme = "";
    },

    fetchThemes() {
      this.$emit("fetchThemes");
    },
    editPluginData(theme) {
            this.editTheme = theme;
            this.$bvModal.show("edit-plugin-modal");
        },

    deletePlugin(id, name) {
      Swal.fire({
        title: "Are you sure?",
        text: `Do you want to delete plugin ${name}?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.delete(id);
        }
      });
    },

    async delete(id) {
      this.loading = true;
      try {
        const resp = await axios.delete(
          `${process.env.VUE_APP_API_URL}/remote-plugin/delete/${id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("_t")}`,
            },
          }
        );

        if (resp.data.success) {
          this.showToast("success", resp.data.message);
          this.fetchPlugins();
        } else {
          this.showToast("danger", resp.data.message || "Failed to delete plugin");
        }
      } catch (error) {
        if (error.response) {
          this.showToast("danger", error.response.data.message || "An error occurred");
        } else if (error.request) {
          this.showToast("danger", "No response received from server. Please check your network.");
        } else {
          this.showToast("danger", "Error in request: " + error.message);
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>



<style>
#theme-table th:first-child {
    width: 100px;
}

#theme-table th:last-child {
    width: 100px;
}

#theme-table td {
    word-break: break-all;
}
</style>
